import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { SessionStoreEffects } from './effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('session', reducer),
        EffectsModule.forFeature([SessionStoreEffects])
    ],
    providers: []
})
export class SessionStoreModule {}
